export default {
  type: 'en-GB',
  confirming: 'Confirming...',
  paymentInfo:
    'The first monthly payment will be debited after the bicycle has been delivered or picked-up.',
  errors: {
    processing:
      "Well, this is awkward! 🚧 Your request took a detour. Let's give it another shot! If it still doesn't work, our support team is ready to rescue.",
    bike_not_available:
      'It looks like the new bike you selected is not available anymore. Such a bummer! Would you like to choose another one?'
  },
  statusMessage:
    'Unfortunately, there is no active subscription on your account at the moment. If this is incorrect or if you have any questions about (changing) a bike, please contact us at <a>support@bikeflip.nl</a> or call <strong>030-2271921</strong>.',
  bikeTitles: {
    prev: 'Previous bike',
    current: 'Current bike',
    new: 'New bike'
  },
  currentBike: {
    month: 'month'
  },
  emptyDescription: {
    '404Bikes': 'No Bikes found',
    '404Details': 'No Details found'
  },
  productSelection: {
    title: 'Select a bike',
    description:
      'You have only one bike in this subscription, so we already selected it for you'
  },
  flip: {
    title: "'Flip' your bike!",
    title_in_page: 'Outgrown your bikes?',
    button: "Request a 'flip'",
    confirmationMessage:
      'We will start right away! You will receive a confirmation of the flip request through mail.'
  },
  add: {
    title: 'Add an extra bike',
    intro:
      'This feature is for an additional bike only - if you want to flip your current bike you can use the flip feature.',
    title_in_page: 'Need another bike?',
    button: 'Add a bike',
    confirmationMessage:
      'We will start right away! You will receive a confirmation through an e-mail soon.'
  },
  return: {
    title: 'Return bikes',
    charge_day:
      'You subscription is set to renew on <strong>{{- day}}</strong>. You may keep the bikes until then.',
    outside_service_area:
      'You are outside service area. You may drop-off at our concept store.',
    address: 'Address: <strong>{{address}}</strong>',
    opening_times: 'Opening times:',
    steps: {
      choose_bike: 'Choose a bike to return',
      select_reason: 'Select a reason',
      choose_pickup_dropoff: 'Choose dropoff location',
      confirm: 'Confirm'
    },
    reasons: {
      have_bigger_bike: 'We already have a larger bike',
      given_bike: 'We were given a bike',
      disappointing_quality: 'The quality of the bike was disappointing',
      other: 'Other'
    },
    pickup_confirmation_text:
      'We will be at your door step to pickup the bike on {{- pickupDateTime}}.',
    dropoff_confirmation_text:
      'You have chosen to dropoff the bike at our {{dropoff_location}} concept store.',
    confirm_outro: 'You will receive a confirmation email from us.',
    in_progress: 'Return in progress'
  },
  day: {
    ma: 'Monday',
    di: 'Tuesday',
    wo: 'Wednesday',
    do: 'Thursday',
    vr: 'Friday',
    za: 'Saturday'
  },
  steps: {
    continue: 'Continue',
    flip: {
      title: 'Choose your new bike',
      selectSize: 'Choose your bike size',
      selectInput: {
        sizePlaceHolder: '--Select a size--'
      }
    },
    add: {
      title: '',
      selectSize: 'Choose your bike size',
      selectInput: {
        sizePlaceHolder: '--Select a size--'
      }
    },
    sizeBike: {
      description: {
        currentSize: 'Current size: ',
        text: 'Need help picking the right size? Check out ',
        link: {
          text: 'our size table',
          url: 'https://bikeflip.nl/en/pages/kinderfiets-maattabel'
        },
        reasonText: 'What is the reason for the flip?'
      },
      selectInput: {
        sizePlaceHolder: '--Select a size--',
        sizeValues: {
          12: '12 inch: 2-4 years',
          14: '14 inch: 3-5 years',
          16: '16 inch: 4-6 years',
          18: '18 inch: 6-7 years',
          20: '20 inch: 7-8 years',
          22: '22 inch: 8-9 years',
          24: '24 inch: 9-10 years',
          26: '26 inch: 10-12 years',
          28: '28 inch: > 12 years',
          L: 'Balance bike: < 3 years'
        },
        reasonPlaceHolder: '--Reason of the flip--',
        reasonOtherPlaceHolder: 'Please specify',
        reasonValues: {
          small: 'Bike has become too small',
          broken: 'Bike is broken',
          unsatisfied: 'Not satisfied',
          other: 'Other'
        }
      },
      advised: 'advised'
    },
    selectBike: {
      title: 'Choose your new bike!',
      description: {
        textPrefix:
          'Would you like to take a detailed look at the bikes? Then go to ',
        textSuffix: 'and then enter the chosen bike here.'
      },
      searchBar: {
        placeholder: 'Search a bike'
      },
      infobox: {
        url: 'https://bikeflip.nl/en/collections'
      },
      modal: {
        title: 'Bike details',
        button: 'Pick this bike'
      }
    },
    deliveryMoment: {
      title: 'Make an appointment',
      subTitle: 'Delivery or pickup?',
      address: {
        changeLabel: 'Change address',
        modal: {
          title: 'Address information',
          ok: 'Update',
          cancel: 'Cancel',
          info: 'If you change the address here, it will also change the default address in your account.',
          form: {
            address: {
              label: 'Address',
              rules: {
                required: 'Street name is required.',
                maxLength: 'Street name longer than 70 characters.'
              }
            },
            houseNr: {
              rules: {
                required: 'House number is required.',
                maxLength: 'House number is longer than 70 characters.'
              }
            },
            postalCode: {
              label: 'Postal code',
              rules: {
                required: 'Postal code is required.',
                pattern: 'fill in a correct postal code. Ex. 0000AB'
              }
            },
            city: {
              label: 'City',
              rules: {
                required: 'City is required.',
                maxLength: 'City is longer than 50 characters.'
              }
            }
          }
        }
      },
      fulfillmentType: {
        description: {
          prefix: 'Check out the',
          middle: 'delivery area',
          link: 'https://bikeflip.nl/en/pages/bezorggebied',
          suffix: ' and see what this means for you.'
        },
        delivery: {
          title: 'Delivery',
          description:
            'Click and select which day and time slot suits you best.',
          within_service_area: 'We only deliver within the service area',
          current_address: 'Your provided address seems to be {{address}}'
        },
        pickup: {
          title: 'Pickup',
          description:
            'Click and choose the location and time that suits you best.',
          donation_description:
            'Click and choose the time that suits you we will come pick it up.'
        },
        dropoff: {
          title: 'Dropoff',
          description:
            'Click and choose the location and time that suits you best to bring the bike(s) to us.'
        }
      },
      calendar: {
        title: 'Which moment suits you?',
        selectedMoment: {
          prefix: 'Chosen moment: ',
          middle: ' on ',
          suffix: ' between '
        },
        modal: {
          title: 'Timeslot',
          subTitle: 'When is the best time to deliver on',
          ok: 'Select',
          cancel: 'Cancel'
        },
        button: 'Go to confirm'
      },
      areaMessage:
        'The address provided is outside our current service area, but you can <strong>pick up the bike from us</strong> the next working day!'
    },
    confirmation: {
      title: 'Check and confirm.',
      description:
        '<p>Double check your information so that we can properly process your order. You will receive a confirmation email soon with all the details.</p>',
      button: 'Confirm'
    }
  },
  donation: {
    thankYou: {
      title: 'Thank you for your donation!',
      description: "We'll send you an email with further instructions."
    },
    fields: {
      email: {
        label: 'Email address',
        placeholder: 'Email address',
        required: 'Please enter your email address',
        invalid: 'Invalid email address'
      },
      phone: {
        label: 'Phone number',
        placeholder: 'Phone number',
        required: 'Please enter your phone number'
      },
      firstName: {
        label: 'First name',
        placeholder: 'First name',
        required: 'Please enter your first name'
      },
      lastName: {
        label: 'Last name',
        placeholder: 'Last name',
        required: 'Please enter your last name'
      },
      street: {
        label: 'Street',
        placeholder: 'Street',
        required: 'Please enter your street'
      },
      houseNumber: {
        label: 'House number',
        placeholder: 'House number',
        required: 'Please enter your house number'
      },
      postalCode: {
        label: 'Postal code',
        placeholder: 'Postal code',
        required: 'Please enter your postal code'
      },
      city: {
        label: 'City',
        placeholder: 'City',
        required: 'Please enter your city'
      }
    },
    bikeSize: {
      label: 'Type of bike',
      placeholder: 'Select the type of bike you want to donate',
      required: 'Please choose which type of bike you want to donate',
      options: {
        loopfiets: 'Balance bike',
        child22: "Children's bike up to 22 inch",
        size24: 'Bike from 24 inch'
      }
    },
    quantity: {
      label: 'Quantity of bikes',
      required: 'Please choose how many bikes you want to donate',
      moreThan15: 'More than 15'
    },
    pickupDate: {
      label: 'Pickup date',
      required: 'Please choose a date'
    },
    outsideDeliveryArea:
      'Sorry, this postal code is outside our delivery area.',
    chosenDateLabel: 'Chosen date:',
    submit: 'Donate your bike'
  },
  feedback: {
    title: 'Feedback? Let us know',
    placeholder: 'We would love to hear about your experiences or ideas',
    submit: 'Share',
    submitted: 'Thank you for your feedback 💚'
  },
  stolenBike: 'Was your bike stolen?'
};
